import React from 'react'

const ProgressBar = ({ progressValue }) => {
    const Parentdiv = {
        height: '0.7rem',
        borderRadius: '8px',
        backgroundColor: 'var(--color-bg)',
        marginBottom: '1rem',
        width: '100%',
    }
    
    const Childdiv = {
        height: '0.7rem',
        backgroundColor: 'var(--color-primary-variant)',
        borderRadius: '8px',
        fontSize: '0.7rem',
        textAlign: 'right',
        paddingLeft: '0.5rem',
        paddingRight: '2.5rem',
        width: `${progressValue}%`,
    }

    const progresstext = {
        color: 'var(--color-bg-variant)',
        fontWeight: 800,
    }

    return (
        <div style={Parentdiv} >
            <div style={Childdiv}>
                <span style={progresstext}>{`${progressValue}%`}</span>
            </div>
        </div>
    )
}

export default ProgressBar

